const state = {
 collapsed: false,
};

const actions = {};

const mutations = {
 CHANGE_COLLAPSE_STATE(state, collapse_state) {
  state.collapsed = collapse_state;
 },
 RESIZE_IF_SIDEBAR_EXPANDED() {
  let main_content = document.getElementById('main_content_div');
  if(main_content && main_content.classList){
   main_content.classList.add('expanded_sidebar');
  }
 }
};

export default {
 state,
 actions,
 mutations
}
